import moment from 'moment-timezone';
import { htmlSafe } from '@ember/template';

import type { IBufferInfo, IPlanningsKpis } from 'volta/models/types/stats';
import type IntlService from 'ember-intl/services/intl';
import type { TAduFrequency } from 'volta/models/types/planning-settings';

export const BufferIconBase64 =
  'image://data:image/png;base64,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';

export function symbolStyle(serie?: { color: string; 'stroke-dasharray'?: boolean }) {
  return (
    serie &&
    serie.color &&
    htmlSafe(
      serie['stroke-dasharray']
        ? `border: 2px solid ${serie.color};background: transparent;`
        : `background-color:${serie.color}`
    )
  );
}

export const FrequencyDict: Record<TAduFrequency,
  { xAxis: string; period: moment.unitOfTime.StartOf }> = {
  DAILY: { xAxis: 'L', period: 'days' },
  WEEKLY: { xAxis: 'Wo YYYY', period: 'weeks' },
  MONTHLY: { xAxis: 'MMM YYYY', period: 'months' },
  QUARTERLY: { xAxis: 'Q', period: 'quarters' },
  YEARLY: { xAxis: 'YYYY', period: 'years' }
};

export const dateFormatter = (date: moment.MomentInput, frequency?: TAduFrequency) => {
  return moment(date).format(frequency ? FrequencyDict[frequency].xAxis : 'YYYY-MM-DD');
};

export function mapSeries<C extends string, S extends string>(
  defs: TSeriesDefinitions<C, S>,
  fn: (
    chartKey: C,
    chartOpt: TChartOption<S>,
    seriesKey: S,
    seriesOpt: TSeriesOption<S>,
    index: number
  ) => void
) {
  let index = 0;
  Object.entries(defs).reduce((result, [chartKey, chartOpt]: [C, TChartOption<S>]) => {
    Object.entries(chartOpt.series).forEach(([seriesKey, seriesOpt]: [S, TSeriesOption<S>]) => {
      result[seriesKey] = seriesOpt;
      fn(chartKey, chartOpt, seriesKey, seriesOpt, index);
      index++;
    });
    return result;
  }, {} as Record<S, TSeriesOption<S>>);
}

export function extractLabels<C extends string, S extends string>(
  defs: TSeriesDefinitions<C, S>,
  intl: IntlService
) {
  const result: Record<string, string> = {};
  Object.entries(defs).forEach(([chartKey, chartOpt]: [C, TChartOption<S>]) => {
    const label = intl.t(chartOpt.legendLabel ?? chartKey);
    if (label) {
      result[chartKey] = intl.t(chartOpt.legendLabel ?? chartKey);
    }

    Object.entries(chartOpt.series).forEach(([serieKey, serieOpt]: [S, TSeriesOption<S>]) => {
      const label = intl.t(serieOpt.label ?? serieKey);
      if (label) {
        result[serieKey] = label;
      }

      if (serieOpt.tooltipOverride?.data) {
        const tooltipLabel = intl.t(
          serieOpt.tooltipOverride.label ?? serieOpt.tooltipOverride.data
        );
        if (tooltipLabel) {
          result[serieOpt.tooltipOverride.data] = tooltipLabel;
        }
      }
    });
  });
  return result;
}

export function chartDataFromDashboardKpis(data?: IPlanningsKpis) {
  const LEVELS = ['Critical', 'High', 'Medium', 'Low', 'OTOG'];
  const {
    inventoryDate,
    avgStockValue,
    stockouts,
    stockoutsWithDemand,
    availabilityRate,
    availabilityRateWithDemand
  } = data || {};

  const keys: Record<keyof Pick<IPlanningsKpis, 'bufferPerformance' | 'eaBufferPerformance'>,
    string> = {
    bufferPerformance: 'buffer',
    eaBufferPerformance: 'eaBuffer'
  };
  const out: Record<string, any[] | undefined> = {
    inventoryDate,
    avgStockValue: avgStockValue?.data,
    stockouts: stockouts?.data,
    stockoutsWithDemand: stockoutsWithDemand?.data,
    availabilityRate: availabilityRate?.data,
    availabilityRateWithDemand: availabilityRateWithDemand?.data
  };
  LEVELS.forEach((level) => {
    Object.keys(keys).forEach((key: 'bufferPerformance' | 'eaBufferPerformance') => {
      out[keys[key] + level] =
        data?.[key]?.percentsPerPeriod?.[level.toLowerCase() as keyof IBufferInfo<number[]>];
    });
  });
  return out;
}
